import { useState, useEffect, useCallback } from "react";
import { useGoogleLoader } from "../components/GoogleLoaderProvider.js";
import { googleAutocompleteOptions } from "./useGoogleAutocomplete.js";
const useGeocoder = () => {
  const loader = useGoogleLoader(), [geocoder, setGeocoder] = useState();
  useEffect(() => {
    loader == null || loader.importLibrary("geocoding").then(({ Geocoder }) => {
      const geocoder2 = new Geocoder();
      setGeocoder(geocoder2);
    });
  }, [loader]);
  const getGeocoderResult = useCallback(
    async (gcr) => {
      try {
        const { results } = await (geocoder == null ? void 0 : geocoder.geocode({
          ...gcr,
          ...gcr.placeId ? {} : {
            componentRestrictions: googleAutocompleteOptions.componentRestrictions
          }
        })) ?? {};
        return results == null ? void 0 : results[0];
      } catch (e) {
        console.error("[getGeocoderResult -> Geocoder] Error", e);
      }
    },
    [geocoder]
  );
  return geocoder ? getGeocoderResult : void 0;
};
export {
  useGeocoder
};
//# sourceMappingURL=useGeocoder.js.map
